var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStructure = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 14,
  viewBox: "0 0 16 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M15.3891 1.7987H0.610889C0.273678 1.7987 0 1.39579 0 0.899348C0 0.402908 0.273678 0 0.610889 0H15.3891C15.7263 0 16 0.402908 16 0.899348C16 1.39579 15.7263 1.7987 15.3891 1.7987Z",
  fill: "#CCCCCC"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.3682 3.33333H0.631845C0.283067 3.33333 0 3.67455 0 4.09498V13.2383C0 13.6588 0.283067 14 0.631845 14H15.3682C15.7169 14 16 13.6588 16 13.2383V4.09498C16 3.67455 15.7169 3.33333 15.3682 3.33333ZM6.57119 12.4767L10.3799 4.85664H13.8926L10.0838 12.4767H6.57119ZM2.00842 12.4767L5.81719 4.85664H9.39638L5.58762 12.4767H2.00842ZM4.83361 4.85664L1.26369 11.9984V4.85664H4.83361ZM11.0674 12.4767L14.7363 5.13642V12.4767H11.0674Z",
  fill: "#1D1D1B"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgStructure);
export { ForwardRef as ReactComponent };